import React from 'react'
import Nav from '../components/Nav/Nav'
import Project from '../components/Project/Project'

function ProjectPage() {
    return (
        <section>
            <Nav/>
            <div className="container-box">
                <Project/>
            </div>
        </section>
    )
}

export default ProjectPage
